import { LoadReligions } from 'domain/usecases/religion/load-religions'
import { ReligionRepository } from 'repository/interfaces/religion-repository'

export class RemoteLoadReligions implements LoadReligions {
  private readonly religionRepository: ReligionRepository

  constructor(religionRepository: ReligionRepository) {
    this.religionRepository = religionRepository
  }

  load(): Promise<LoadReligions.Model> {
    return this.religionRepository.loadReligions()
  }
}
